import { useEffect, useState } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../../components/BannerOne";
import CardsFormatOne from "../../../components/CardsFormatOne";
import CardsFormatTwo from "../../../components/CardsFormatTwo";

import IntroductionBlock from "../../../components/IntroductionBlock";
// Constants
import { TITLE, SUB_TITLE, FIRST_BUTTON_NAME, FIRST_BUTTON_LINK, TITLE_CARDS_EXP, SUB_TITLE_CARDS_EXP, ALL_CARD_EXP_ROWS } from "./PartnerProClubConstants";
import { INTRO_EYE_BROWN_HEADER, INTRO_TITLE, INTRO_TEXT } from "./PartnerProClubConstants";
import { EYE_BROWN_HEADER_CARDS_TWO, EYE_BROWN_HEADER_CARDS, TITLE_CARDS, SUB_TITLE_CARDS, ALL_CARD_ROWS } from "./PartnerProClubConstants";
import { TITLE_ONE, TITLE_TWO, TITLE_THREE, TITLE_FOUR, SUB_TITLE_ONE, SUB_TITLE_TWO, SUB_TITLE_THREE, SUB_TITLE_FOUR, TITLE_FIVE, TITLE_SIX, SUB_TITLE_FIVE, SUB_TITLE_SIX, CARDS_FINAL_TEXT } from "./PartnerProClubConstants";
// Images
// import partnerProgramLogo from '../../../assets/img/partnerProgram/banner.png';
import proClubLogo from '../../../assets/img/proClub_public/PartnerProClubLogo.png';
import wave from '../../../assets/img/partnerPortal/EnablementSales/full wave.png';
// Scss
import '../../../assets/css/partnerProgram.scss';
import NewsSectionTwo from "../../../components/NewsSectionTwo";
import ExpertsSection from "../../../components/ExpertsSection";
import PartnerCertificationsDTO from "../../../models/PartnerCertificationsDTO";

// actions
import * as partnerPortalAction from "../../../actions/partnerPortal/PartnerPortalAction";



function PartnerProClubPublic() {

  let history = useHistory();
  const [certificationList, setCertificationList] = useState<Array<PartnerCertificationsDTO>>();

  const cert1: PartnerCertificationsDTO = new PartnerCertificationsDTO("Diogo Santos", "");
  const cert2: PartnerCertificationsDTO = new PartnerCertificationsDTO("Diogo Santos", "");
  const cert3: PartnerCertificationsDTO = new PartnerCertificationsDTO("Diogo Santos", "");
  const cert4: PartnerCertificationsDTO = new PartnerCertificationsDTO("Diogo Santos", "");
  const ALL_CERTS: Array<PartnerCertificationsDTO> = new Array<PartnerCertificationsDTO>(cert1, cert2, cert3, cert4);

  useEffect(() => {
    canYouHaveAccess();
    //getCertification();

  }, []);

  return (
    <>
      <div className="backgroundImage">

        <BannerOne logo={proClubLogo} bannerImage={wave} title={TITLE} subTitle={SUB_TITLE} buttonName={FIRST_BUTTON_NAME} buttonLink={FIRST_BUTTON_LINK} isArrowDown={true} />
        <IntroductionBlock eyeBrownHeader={INTRO_EYE_BROWN_HEADER}  title={INTRO_TITLE} text={INTRO_TEXT} withPadding={false} />

        <CardsFormatOne eyeBrownHeader={EYE_BROWN_HEADER_CARDS} title={TITLE_CARDS} subTitle={SUB_TITLE_CARDS} cards={ALL_CARD_ROWS} />

        <CardsFormatTwo eyeBrownHeader={EYE_BROWN_HEADER_CARDS_TWO} title={TITLE_CARDS_EXP} subTitle={SUB_TITLE_CARDS_EXP} cards={ALL_CARD_EXP_ROWS} cardHeight={400} />
        {/* <IntroductionBlock text={CARDS_FINAL_TEXT} withPadding={false} /> */}

        {/* <div className="howSectionPosition">
        <IntroductionBlock title={"Welcome to Pro Club"} text={"Congratulations to our members who achieved Pro Club status in March 2024"} withPadding={false} removeMargin={true} />
          {(certificationList === undefined) ? "" : <ExpertsSection partnerCertificationList={certificationList} />}
        </div>  */}


        <div id="faq" className="d-flex align-items-center flex-column justify-content-center m-auto width64">
          <div className="faqTitle">
            <div className="faqHeader">
                <div className="faqTitleText">FAQs</div>         
            </div>
          </div>
        
          <NewsSectionTwo title={TITLE_ONE} subTitle={SUB_TITLE_ONE} active={true}/>
          <NewsSectionTwo title={TITLE_TWO} subTitle={SUB_TITLE_TWO} active={true} />
          <NewsSectionTwo title={TITLE_THREE} subTitle={SUB_TITLE_THREE} active={true} />
          <NewsSectionTwo title={TITLE_FOUR} subTitle={SUB_TITLE_FOUR} active={true} />
          <NewsSectionTwo title={TITLE_FIVE} subTitle={SUB_TITLE_FIVE} active={true} />
          <NewsSectionTwo title={TITLE_SIX} subTitle={SUB_TITLE_SIX} active={true} />
        </div>
        
      </div >
      
    </>
  );

  function canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

  async function getCertification() {
    partnerPortalAction.getPartnerCertifications("ALL", 0).then(response => {
        setCertificationList(response.data);
    }).catch(err => {
        console.error('certifications not fetch!', err);
    });
}

}

export default PartnerProClubPublic;

